export default async function getIPAddress () {
  return fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      return data.ip
    })
}
